<template>
  <div>
    <div class="container-buttons">
      <button @click="showModal" class="btn-custom btn-cobranca mb-3">
        <i class="fa fa-plus"></i> Cadastrar Novo Carro
      </button>
    </div>
    <modal name="modal" :adaptive="true" classes="modal-override">
      <p class="text-center mt-1 modal-title">Cadastrar Carro</p>
      <hr />
      <form @submit.prevent="createCar" class="container">
        <div class="row">
          <div class="col-md-6">
            <fg-input
              label="Marca"
              v-model="newCar.manufacturer"
              @keyup.native="toUpperManufacturer"
              required
            ></fg-input>
          </div>
          <div class="col-md-6">
            <fg-input label="Modelo" v-model="newCar.model"
            @keyup.native="toUpperModel" 
            required></fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input
              label="Placa"
              v-model="newCar.plate"
              v-mask="'AAA-#X##'"
              @keyup.native="toUpper"
              required
            ></fg-input>
          </div>
          <div class="col-md-6">
            <fg-input label="Chassi" v-model="newCar.chassis" 
            @keyup.native="toUpperChassis"
            required></fg-input>
          </div>
        </div>

        <div>
          <button class="btn-custom btn-cobranca btn-modal" type>Salvar</button>
        </div>
        <div class="clearfix"></div>
      </form>
    </modal>
    <card title="Carros Cadastrados" subTitle="Lista de carros cadastrados">
      <div slot="raw-content" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <th>ID</th>
            <th>Marca</th>
            <th>Modelo</th>
            <th>Placa</th>
            <th>Chassi</th>
            <th v-if="userRole === 'admin'">Ações</th>
          </thead>
          <tbody>
            <tr v-for="car in cars" :key="car.id">
              <td>{{ car.id }}</td>
              <td>{{ car.manufacturer }}</td>
              <td>{{ car.model }}</td>
              <td>{{ car.plate }}</td>
              <td>{{ car.chassis }}</td>
              <td v-if="userRole === 'admin'">
                <p-button
                  @click.prevent.native="deleteCar(car.id)"
                  type="danger"
                  outline
                  icon
                  title="Apagar Carro"
                >
                  <i class="fa fa-ban btn-delete"></i>
                </p-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>
    <Pagination
      :currentPage="pagination.currentPage"
      :totalPages="pagination.totalPages"
      v-on:update="updatePagination"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Pagination
  },
  computed: {
    cars() {
      return this.$store.getters.cars;
    },
    pagination() {
      return this.$store.getters.carsPagination;
    },
    userRole() {
      return this.$store.getters.user.role;
    }
  },
  data() {
    return {
      newCar: {
        manufacturer: "",
        model: "",
        plate: "",
        chassis: ""
      }
    };
  },
  methods: {
    ...mapActions(["fetchCars", "addCar", "removeCar"]),
    toUpper(e) {
      this.newCar.plate = e.target.value.toUpperCase();
    },
    toUpperManufacturer(e) {
      this.newCar.manufacturer = e.target.value.toUpperCase();
    },
    toUpperModel(e) {
      this.newCar.model = e.target.value.toUpperCase();
    },
    toUpperChassis(e) {
      this.newCar.chassis = e.target.value.toUpperCase();
    },
    showModal() {
      this.$modal.show("modal");
    },
    async updatePagination({ currentPage }) {
      await this.fetchCars({ currentPage });
    },
    async createCar() {
      try {
        await this.addCar({ car: this.newCar });
        Swal.fire("Sucesso!", "Carro criado com sucesso", "success");
      } catch (err) {
        Swal.fire("Ops!", "Não foi possível criar o carro", "error");
      }
    },
    async deleteCar(id) {
      const result = await Swal.fire({
        title: "Atenção!",
        text: "Esta ação irá apagar o carro, deseja prosseguir?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        try {
          await this.removeCar({ id });
          Swal.fire({
            title: "Sucesso!",
            text: "Carro apagado com sucesso",
            icon: "success"
          });
        } catch (e) {
          Swal.fire({
            title: "Ops!",
            text: "Não foi possível apagar o carro",
            icon: "error"
          });
        }
      }
    }
  },
  async mounted() {
    try {
      await this.fetchCars();
    } catch (err) {
      Swal.fire("Ops!", "Não foi possível carregar os carros", "error");
    }
  }
};
</script>

<style lang="scss" scoped>
fg-input {
  background-color: red !important;
  color: red !important;
}
.modal-title {
  font-size: 20px;
}
.btn-modal {
  padding: 10px 60px;
}
.container-body {
  display: flex;

  p {
    font-size: 16px;
  }
}
i.btn-config {
  font-size: 40px;
}
.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-cobranca {
    background: #9dcf6b;

    &:hover {
      background: #82ac58;
    }
  }

  &.btn-modal {
    padding: 10px 50px;
  }
}

.btn-outline-success {
  border-color: #9dcf6b;
  color: #9dcf6b;

  &:hover {
    background: #9dcf6b;
    border-color: #9dcf6b;
  }
}
</style>
<style>
@media (max-width: 425px) {
  .modal-override {
    margin: auto;
    max-width: 400px;
    height: 385px !important;
  }
}
</style>

